<template>
    <div>
    
        <div class="subheader py-6 py-lg-8 subheader-transparent" id="kt_subheader">
            <div class="container">

                <div class="d-flex justify-content-between">

                    <h1 class="pages-title my-1 mr-5">HISTORIQUE</h1>

                    <div>
                        <a target="_blank" :href="export_url+'?admin='+admin+'&keyword='+keyword" class="btn btn-sm bg-blue py-4 pl-6 pr-10">
                            <span class="svg-size-20 svg-icon svg-icon-white svg-icon-2x mr-5">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <polygon points="0 0 24 0 24 24 0 24"/>
                                    <path d="M5.85714286,2 L13.7364114,2 C14.0910962,2 14.4343066,2.12568431 14.7051108,2.35473959 L19.4686994,6.3839416 C19.8056532,6.66894833 20,7.08787823 20,7.52920201 L20,20.0833333 C20,21.8738751 19.9795521,22 18.1428571,22 L5.85714286,22 C4.02044787,22 4,21.8738751 4,20.0833333 L4,3.91666667 C4,2.12612489 4.02044787,2 5.85714286,2 Z" fill="#000000" fill-rule="nonzero" opacity="0.3"/>
                                    <path d="M14.8875071,11.8306874 L12.9310336,11.8306874 L12.9310336,9.82301606 C12.9310336,9.54687369 12.707176,9.32301606 12.4310336,9.32301606 L11.4077349,9.32301606 C11.1315925,9.32301606 10.9077349,9.54687369 10.9077349,9.82301606 L10.9077349,11.8306874 L8.9512614,11.8306874 C8.67511903,11.8306874 8.4512614,12.054545 8.4512614,12.3306874 C8.4512614,12.448999 8.49321518,12.5634776 8.56966458,12.6537723 L11.5377874,16.1594334 C11.7162223,16.3701835 12.0317191,16.3963802 12.2424692,16.2179453 C12.2635563,16.2000915 12.2831273,16.1805206 12.3009811,16.1594334 L15.2691039,12.6537723 C15.4475388,12.4430222 15.4213421,12.1275254 15.210592,11.9490905 C15.1202973,11.8726411 15.0058187,11.8306874 14.8875071,11.8306874 Z" fill="#000000"/>
                                </g>
                            </svg></span>
                            <span class="text-color-white font-size-14 vertical-align-middle"> Exporter pour Excel</span>
                        </a>
                    </div>
                </div>
  
            </div>
        </div>

        <div class="d-flex flex-column-fluid">

            <div class="container">
                <div class="row">
                    <div class="col-md-12">

                        <div class="card card-custom gutter-b">
                            <div class="card-body">
                                    <div class="row mb-10">
                                        <div class="col-md-5">
                                            <div class="search-zone">
                                                <div class="input-icon input-icon-right">
                                                    <input v-model="keyword" type="text" name="keyword" class="w-100 form-control" id="search-table-dynamic-v1" placeholder="Recherche ..." value="">
                                                    <span>
                                                        <i class="flaticon2-search-1 icon-md"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4 historique-search">
                                            <select v-model="admin" name="admin_id" class="w-100 form-control" id="kt_select2_1">
                                                <option v-for="admin in admins" :key="`admin_${admin.id}`" :value="admin.id">
                                                    {{ admin.nom+" "+admin.prenom }}</option>
                                            </select>
                                        </div>
                                        <div class="col-md-3">
                                            <button @click="filter()" type="button" class="text-center btn btn-sm bg-dark-blue text-color-white py-4 px-15">
                                                <span class="font-size-14 vertical-align-middle"> Filtrer maintenant</span>
                                            </button>
                                        </div>
                                    </div>

                                <div class="timeline timeline-2 historique-time-line">
                                    <div class="timeline-bar"></div>
                                    <div v-for="historique in historiques" :key="`historique_${historique.id}`" class="timeline-item init">
                                        <div class="timeline-badge">
                                            <i class="far fa-circle"></i>
                                        </div>
                                        <div class="timeline-content align-items-center">
                                            <p class="line-1">
                                                <span class="text-colored">{{ historique.action }}</span> {{ new Date(historique.created_at).toLocaleString() }}
                                            </p>
                                            <p class="line-2">
                                                <strong >{{ historique.admin.nom+" "+historique.admin.prenom }}</strong> {{ historique.commentaire }}</p>
                                            <div class="line-profile d-flex flex-center pb-6">
                                                <!--begin::Bullet-->
                                                <span class="bullet bullet-bar align-self-stretch mr-4 my-1"></span>
                                                <!--end::Bullet-->
                                                <!--begin::Text-->
                                                <div class="d-flex flex-column flex-grow-1">
                                                    <a href="#" class="line-profile-name">Par {{ historique.admin.nom+" "+historique.admin.prenom }}</a>
                                                    <span class="text-colored line-profile-proffesion">{{ historique.admin.role_libelle }}</span>
                                                </div>
                                                <!--end::Text-->
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="historiques.length == 0" class="card py-5">
                                        <h4 class="text-center"> Aucun résultat trouver.</h4>
                                    </div>
                                </div>

                                <div v-if="nextPage != null" class="row">
                                    <div class="col-md-12">
                                        <button @click="loadMore()" type="button" class="w-100 font-size-16 btn bg-blue text-color-white">
                                            <span class="svg-icon svg-icon-white svg-icon-2x">
                                                <!--begin::Svg Icon | path:C:\wamp64\www\keenthemes\themes\keen\theme\demo1\dist/../src/media/svg/icons\Navigation\Arrow-from-top.svg-->
                                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                        <polygon points="0 0 24 0 24 24 0 24"/>
                                                        <rect fill="#000000" opacity="0.3" x="11" y="7" width="2" height="14" rx="1"/>
                                                        <path d="M6.70710678,20.7071068 C6.31658249,21.0976311 5.68341751,21.0976311 5.29289322,20.7071068 C4.90236893,20.3165825 4.90236893,19.6834175 5.29289322,19.2928932 L11.2928932,13.2928932 C11.6714722,12.9143143 12.2810586,12.9010687 12.6757246,13.2628459 L18.6757246,18.7628459 C19.0828436,19.1360383 19.1103465,19.7686056 18.7371541,20.1757246 C18.3639617,20.5828436 17.7313944,20.6103465 17.3242754,20.2371541 L12.0300757,15.3841378 L6.70710678,20.7071068 Z" fill="#000000" fill-rule="nonzero" transform="translate(12.000003, 16.999999) scale(1, -1) translate(-12.000003, -16.999999) "/>
                                                        <rect fill="#000000" opacity="0.3" x="3" y="3" width="18" height="2" rx="1"/>
                                                    </g>
                                                </svg>
                                            </span>
                                        CHARGER PLUS</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
export default {
    props: {
        token: String,
        export_url: String,
        admins: Array
    },
    data() {
        return {
            nextPage: null,
            historiques: [],
            keyword: "",
            admin: "",
        }
    },
    methods: {
        loadMore() {
            axios.post(`${this.nextPage}&api_token=${this.token}`, {
                'admin': this.admin,
                'keyword': this.keyword
            })
            .then(res => {
                var response = res.data;
                this.historiques = this.historiques.concat(response.data);
                this.nextPage = response.next_page_url;
            });
        },
        filter() {
            axios.post(`/api/historiques?api_token=${this.token}`, {
                'admin': this.admin,
                'keyword': this.keyword
            })
            .then(res => {
                var response = res.data;
                this.historiques = response.data;
                this.nextPage = response.next_page_url;
            });
        },
    },
    mounted() {
        axios.post(`/api/historiques?api_token=${this.token}`)
        .then(res => {
            var response = res.data;
            this.historiques = response.data;
            this.nextPage = response.next_page_url;
        });
    }
}
</script>
